import * as React from "react";
import { styled } from "@mui/material/styles";
import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import Colors from "theme/tokens/colors";
import { Pagarme } from "../icon/pagarme";

const FooterBox = styled(Box)`
  margin-top: 32px;
  background-color: ${Colors.BASE_BLACK_700};
  height: 106px;
  display: flex;
  align-items: center;
`;

export function Footer() {
  return (
    <FooterBox component="footer" sx={{ flexGrow: 1 }}>
      <Container>
        <Pagarme variant="FOOTER" />
      </Container>
    </FooterBox>
  );
}
